import { useContext, useState } from "react";
import { SelectVillage } from "../../components/SelectVillage";
import { Dashboard } from "../../enums/Dashboard";
import { LoadingButton } from "@mui/lab";
import CreateIcon from '@mui/icons-material/Create';
import { Card, CardActions, CardContent, CardHeader } from "@mui/material";
import VspPortalContext from "../../store/VspPortalContext";
import { useVillageWifiHttp } from "./hooks/useVillageWifiHttp";
import { WifiKeyDto } from "../../dtos/WifiKeyDto";
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import { ResidentDto } from "../../dtos/ResidentDto";


type CreateResidentWifiKeyProps = {

    onCreateWifiKey( wifiKeyDto: WifiKeyDto | undefined ): void;
    resident: ResidentDto;

};


export const CreateResidentWifiKey: React.FC<CreateResidentWifiKeyProps> = ( props: CreateResidentWifiKeyProps ) => {

    const { onCreateWifiKey, resident } = props;

    
    const [ canGenerateWifiKey, setCanGenerateWifiKey ] = useState< boolean >( false );
    const [ isGeneratingWifiKey, setIsGeneratingWifiKey ] = useState< boolean >( false );
    const [ village, setVillage ] = useState< string >( '' );


    const { state } = useContext( VspPortalContext );

    const { createResidentWifiKey } = useVillageWifiHttp( );
    
    
    const handleGenerateWifiKeyClick = async() => {

        setCanGenerateWifiKey( false );
        
        setIsGeneratingWifiKey( true );

        const wifiKeyDto = await createResidentWifiKey( {
                
            createdBy: state.username
            , employeeNumber: resident.employeeId
            , villageCode: village as string
            
        });

        setIsGeneratingWifiKey( false );

        if( wifiKeyDto ) {

            onCreateWifiKey( wifiKeyDto );
    
        }

    };
    
    
    const handleSelectVillage = ( villageCode : string ) => {


        setVillage( villageCode );
        setCanGenerateWifiKey( true );

    };


    return(

        <Card sx={{ boxShadow: 5, marginTop: '20px', minWidth: 275 }}>

            <CardHeader 
                sx={{ fontWeight: '600', fontSize: '20px', paddingTop: '5px', paddingBottom: '0' }}
                title="Select Cardholder Current Location"
                avatar={
                    <LocationSearchingIcon />
                }
            />

            <CardContent>
                <SelectVillage asset={ resident.asset } dashboard={ Dashboard.VillageWiFi } onSelectVillage={ handleSelectVillage } />
            </CardContent>

            <CardActions
                sx={{
                    display: "flex",
                    justifyContent: "flex-end"
                }}
            >
                <LoadingButton
                    sx={{ fontWeight: 'bold', height: '55px', marginRight: '10px', textTransform: 'none', width: '150px' }}
                    loadingPosition="start"
                    startIcon={ <CreateIcon /> }
                    variant="contained"
                    disabled={ !canGenerateWifiKey && !isGeneratingWifiKey }
                    onClick={ handleGenerateWifiKeyClick }
                    loading={ isGeneratingWifiKey }
                >
                    Generate
                </LoadingButton>
            </CardActions>

        </Card>

    );

};